import React, { useEffect, useState } from 'react';
import { ActivityIndicator, Image, ScrollView } from 'react-native';
import type { PlayerFollowerProps, PublicPlayerProps } from '../../../types';
import { SocialProfileApi } from '../api';
import PlayerList from '../../PlayerList';
import { useColors } from '../../../constants/useColors';
import { Button, Text, View } from '../../../Components/Themed';
import Pagination from '../../../Components/Pagination';

type PlayerFollowersListProps = {
    status: 'following'|'followers',
    viewing_player:PublicPlayerProps,
    onSelectPlayer?:(p:PublicPlayerProps) => void
    total?:number,
    player_id?:string,
    height?:number,
    onClose:() => void
}

const PlayerFollowersList = ({ status, total, viewing_player, player_id, onClose, onSelectPlayer }:PlayerFollowersListProps) => {
    const Colors = useColors();
    const [ list_data, setData ] = useState<{
        loading:boolean,
        player_followers:PlayerFollowerProps[],
        offset:number
    }>({
        loading:false,
        player_followers:[],
        offset:0
    });
    const { loading, player_followers, offset } = list_data;

    useEffect(() => {
        getDataFromServer(0);
    },[]);

    const getDataFromServer = async(offset:number) => {
        if(loading){ return } //No mashy mashy
        setData({ ...list_data, loading:true });
        let pfs = await SocialProfileApi.getPlayerFollowersByPlayerId(viewing_player.player_id, status, offset);
        setData({
            ...list_data,
            loading:false,
            player_followers:pfs,
            offset
        })
    }


    return (
        <View style={{ flex:1 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:20 }}>
                <Image
                    source={{ uri: viewing_player.profile_pic && viewing_player.profile_pic != '' ? viewing_player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ width: 32, height: 32, borderRadius:100 }}
                    resizeMode='cover'
                />
                <View transparent style={{flex:1, marginLeft:10 }}>
                    <Text theme='h1'>{status}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>{status == 'followers' ? `@${viewing_player.username} Followers`: `Players @${viewing_player.username} is following`}</Text>
                </View>
                {total ?
                <Text theme='h1'>{total}</Text>
                :<></>}
            </View>
            <ScrollView style={{flex:1}}>
            {loading ? 
                <ActivityIndicator
                    size={'large'}
                    color={Colors.text.h1}
                    style={{ padding:10, alignSelf:'center' }}
                />
                :<></>}
                <PlayerList
                    players={player_followers.map(pf => pf.playerDetails as PublicPlayerProps)}
                    onPlayerSelect={onSelectPlayer}
                    options={{
                        direction: 'horizontal',
                        follow_status: player_id?true:false
                    }}
                />
            </ScrollView>
                
            <View type='footer'>
                <Pagination
                offset={offset}
                onNext={() => getDataFromServer(offset + 1)}
                onPrevious={() => getDataFromServer(offset - 1)}
                />
            </View>
            <View type='footer' style={{ flexDirection:'row', padding:10 }}>
                <Button
                    style={{ flex:1 }}
                    title='CLOSE'
                    type='close'
                    onPress={() => onClose()}
                />
            </View>
        </View>
    )
}

export default PlayerFollowersList